import { Avatar } from "@heroui/react";
import { useNavigate } from 'react-router-dom';
import { GroupChatIcon } from '../../assets/icons';
import { stripHtmlTags } from '../../utils/utils';

const SideBarBody = ({
    avatar,
    status,
    name,
    lastMessage,
    unReadMessages,
    setActiveChat,
    activeChat,
    completeItem,
    fetchChatMessages,
    setSearchQuery,
    markSeenMessage,
    chatType,
    setMessage,
    setMessages,
    inputRef
}) => {
    const navigate = useNavigate();

    const handleAvatarClick = (e) => {
        e.stopPropagation();
        if (chatType === 'group') return;

        let targetId = null;
        if (!completeItem.channel_id) {
            // It's a user from search results
            targetId = completeItem.id;
        } else if (completeItem.members && completeItem.members.length > 0) {
            // It's a channel, use the first member (same logic as avatar display in index.jsx)
            const member = completeItem.members[0];
            targetId = member.user_id || member.id;
        }

        if (targetId) {
            navigate(`/partners/partner-detail/${targetId}`);
        }
    };

    const handleSelect = () => {
        setMessage('');
        setMessages([]);
        setTimeout(() => {
            inputRef?.current?.focus();
        }, 100)
        if (!completeItem.channel_id) {

            setActiveChat({ ...completeItem, avatar, chatType: 'individual' });
            setSearchQuery(null)
        } else {
            setActiveChat({ ...completeItem, avatar });
            fetchChatMessages(completeItem.channel_id)
            markSeenMessage(completeItem.channel_id);
            setSearchQuery(null)
        }
    };

    return (
        <div
            role="button"
            tabIndex={0}
            className={`w-full text-left hover:bg-surface-hover ${(activeChat?.channel_id && completeItem?.channel_id) && activeChat?.channel_id === completeItem?.channel_id ? 'bg-surface-active' : ''}`}
            onClick={handleSelect}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleSelect();
                }
            }}

        >
            <div className="flex items-center gap-3 p-4 hover:bg-surface cursor-pointer">
                {chatType === 'group' ?
                    <div className='w-10 h-10 rounded-full bg-mediumgrey/30 flex items-center justify-center'>
                        <GroupChatIcon className='w-6 h-6' />
                    </div>
                    :
                    <button type="button" className="relative w-10 h-10 rounded-full" onClick={handleAvatarClick} aria-label={`View ${name || 'connection'} profile`}>
                        <Avatar
                            src={avatar}
                            classNames={{
                                base: "bg-mediumgrey/30",
                                icon: "text-black/60",
                            }}
                        />
                        {status && (
                            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white" />
                        )}
                    </button>
                }

                <div className="flex-1 min-w-0">

                    <h3 className="font-medium">{name}</h3>
                    <div className='flex justify-between items-center w-full gap-1'>
                        <p className="text-sm text-mediumgrey line-clamp-2">{stripHtmlTags(lastMessage)}</p>
                        {unReadMessages > 0 && <div className='mr-0 text-xs text-white flex items-center justify-center min-w-4 px-2 h-4 rounded-2xl bg-secondary/100'>
                            {unReadMessages}
                        </div>
                        }
                    </div>
                </div>

            </div>
        </div >
    )
}

export default SideBarBody
